/* eslint-disable react/prop-types */
// LIBRARY
import React from 'react';
import { Drawer, Form, Row, Col, Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

// CUSTOM
import { fetchSelectedExamList, updateExamRequest } from 'services/shared/examRequest';
import { UserAccessContext } from 'context/userAccess';
import fetchExamList from 'services/settings/examItem';
import InputForm from '../form/update_form';
import SelectionTable from '../selection_table';
import SelectedTable from '../selected_table';
import { drawerTitle, buttonNames } from '../settings';
import { deactivateItem } from 'services/settings/status';
import DynamicFormAnalyzer from '../dynamic_form_analyzer';
import { showIntegrationCodeModal } from 'shared_components/integration_code_modal';

class UpdatePanel extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isFetchingData: false,
			examList: [],
			selectedExams: [],
			analyzerDynamicForm: [],
			existingDynamicForm: [],
			newItemAnalyzerValue: false,
			resetAnalyzerIsTrue: false,
			isForceDeactivate: false,
		};

		this.formRef = React.createRef();
		this.selectedTable = React.createRef();
		this.formFields = React.createRef();
	}

	handleAnalyzerValue = value => {
		this.setState({ analyzerDynamicForm: value });
	};
	
	setIsForceDeactivate = value => {
		this.setState({ isForceDeactivate: value });
	};

	async componentDidUpdate(prevProps) {
		const { sectionId: secId, specimenId: specId, examRequestId: erId } = this.props;

		const { sectionId: prevSecId, specimenId: prevSpecId, examRequestId: prevErId } = prevProps;

		const propsHasChanged = secId !== prevSecId || specId !== prevSpecId || erId !== prevErId;
		const propsIsNotNull = secId !== null && specId !== null && erId !== null;

		if (propsHasChanged && propsIsNotNull) {
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({ isFetchingData: true }, async () => {
				const { sectionId, specimenId, examRequestId, examRequest } = this.props;
				const selectedExamsList = await fetchSelectedExamList(sectionId, specimenId, examRequestId);
				const examList = await fetchExamList(sectionId, specimenId, true);

				console.log('UpdatePanel - Analyzer codes from API:', selectedExamsList.examRequestAnalyzerCodes);

				this.setState({
					existingDynamicForm: selectedExamsList.examRequestAnalyzerCodes,
					newItemAnalyzerValue: true,
				});

				// if examRequest is Return [null] = [] else = data
				// console.log('selectedExamsList.examRequestItems =>', selectedExamsList);
				const examRequestItems = selectedExamsList.examRequestItems || [];
				// console.log(selectedExamsList);

				// Merge exam request items with exam names from examList
				const selectedExamsWithNames = examRequestItems.map(requestItem => {
					const examDetails = examList.find(exam => exam.examItemID === requestItem.examItemID);
					return {
						...requestItem,
						examItemName: examDetails ? examDetails.examItemName : `Unknown (ID: ${requestItem.examItemID})`
					};
				});

				const activeExamList = examList ? examList.filter(item => item.active === 1) : [];

				this.setState(
					{
						examList: activeExamList,
						selectedExams: selectedExamsWithNames,
						isFetchingData: false,
					},
					() => {
						this.formRef.current.setFieldsValue({
							examRequestName: examRequest.examRequestName,
							examRequestCode: examRequest.examRequestCode,
							specimenID: specimenId,
							sectionID: sectionId,
							examRequestLoinc: examRequest.examRequestLoinc,
							examRequestIntegrationCode: examRequest.examRequestIntegrationCode,
							examRequestSort: examRequest.examRequestSort,
							examRequestActive: (examRequest.examRequestIsActive === 1 && examRequestItems.length > 0) ? true : false,
							examRequestReportTemplate: examRequest.examRequestReportTemplate,
							examRequestAutoSTAT: examRequest.examRequestAutoSTAT === 1 ? true : false,
							examRequestAutoSendOut: examRequest.examRequestAutoSendOut === 1 ? true : false,
						});

						// Set fields value of selected table
						const fieldsValue = {};

						examRequestItems.forEach((item, index) => {
							fieldsValue[`keys_${index}`] = item.examItemID;
							fieldsValue[`examRequestItemGroup_${item.examItemID}`] = item.examRequestItemGroup;
							fieldsValue[`examRequestItemFormula_${item.examItemID}`] =
								item.examRequestItemFormula;
							fieldsValue[`examRequestItemLock_${item.examItemID}`] = item.examRequestItemLock
								? 1
								: 0;
							fieldsValue[
								`examRequestItemPrintable_${item.examItemID}`
							] = item.examRequestItemPrintable ? 1 : 0;
							fieldsValue[`examRequestItemSort_${item.examItemID}`] = item.examRequestItemSort;
						});

						this.formRef.current.setFieldsValue(fieldsValue);
					},
				);

				this.setState({ newItemAnalyzerValue: false });
			});
		}
	}

	onSubmit = () => {
		const { analyzerDynamicForm } = this.state;
		const { onSuccess, examRequest } = this.props;
		const { examRequestID } = examRequest;

		const selectedExamItems = this.selectedTable.current.getSelectedExamItems();
		const formFieldValues = this.formRef.current.getFieldsValue();

		// checking analyzer if is no data or null
		const analyzerCheck = analyzerDynamicForm.map(item => {
			const analyzerData =
				item.analyzerID === null && item.analyzerName === '' && item.examItemAnalyzerCode === '';
			return analyzerData;
		});
		const AnalyzerIsNull = analyzerCheck.includes(true);

		const proceedWithSave = (isInactive = false) => {
			const payload = {
				examRequestID,
				sectionID: formFieldValues.sectionID,
				specimenID: formFieldValues.specimenID,
				examRequestCode: formFieldValues.examRequestCode,
				examRequestIntegrationCode: formFieldValues.examRequestIntegrationCode,
				examRequestLoinc: formFieldValues.examRequestLoinc,
				examRequestName: formFieldValues.examRequestName,
				examRequestSort: examRequest.examRequestSort,
				examRequestReportTemplate: formFieldValues.examRequestReportTemplate,
				examItems: selectedExamItems,
				examRequestActive: isInactive ? 0 : (formFieldValues.examRequestActive === false ? 0 : 1),
				examRequestAnalyzerCodes: AnalyzerIsNull === true ? [] : analyzerDynamicForm,
				examRequestAutoSTAT: formFieldValues.examRequestAutoSTAT === false ? 0 : 1,
				examRequestAutoSendOut: formFieldValues.examRequestAutoSendOut === false ? 0 : 1,
			};

			console.log('Update payload:', payload);

			showIntegrationCodeModal(payload.examRequestIntegrationCode, {
				itemType: 'Exam Request',
				currentItemId: examRequestID,
				onConfirm: () => {
					this.setState({ isLoading: true }, async () => {
						if (payload.examRequestActive === 0 && this.state.isForceDeactivate) {
							await deactivateItem('Exam Request', examRequestID);
						}

						const updatedExamRequest = await updateExamRequest(payload);
						this.setState({ isLoading: false, isForceDeactivate: false });

						if (updatedExamRequest) {
							onSuccess();
						}
					});
				},
			});
		};

		if (selectedExamItems.length === 0) {
			Modal.confirm({
				title: 'Deactivate Exam Request?',
				icon: <ExclamationCircleOutlined />,
				content: (
					<>
						<span style={{ color: '#ff4d4f', fontWeight: 'bold' }}>Warning: If no Exam Items are selected, this Exam Request will be updated as INACTIVE.</span>
						<br /><br />
						Do you want to proceed?
					</>
				),
				okText: 'Proceed',
				cancelText: 'Cancel',
				centered: true,
				onOk: () => proceedWithSave(true),
			});
		} else {
			proceedWithSave(false);
		}
	};

	resetAnalyzer = () => {
		this.setState({ analyzerDynamicForm: [], resetAnalyzerIsTrue: true });

		// set isTrue back to false after 0.5 milliseconds
		setTimeout(() => {
			this.setState({ resetAnalyzerIsTrue: false });
		}, 500);
	};

	onDragAndDropRow = selectedExams => {
		this.setState({ selectedExams });
	};

	onSelectSelectionTable = selectedExam => {
		const { selectedExams } = this.state;
		const newSelectedExams = [...selectedExams, selectedExam];

		this.setState({ selectedExams: newSelectedExams });
	};

	onDeselectSelectionTable = selectedExam => {
		const { selectedExams } = this.state;
		const newSelectedExams = selectedExams.filter(
			exam => exam.examItemID !== selectedExam.examItemID,
		);

		this.setState({ selectedExams: newSelectedExams }, () => {
			if (newSelectedExams.length === 0) {
				this.formRef.current.setFieldsValue({ examRequestActive: false });
			}
		});
	};

	onSelectAllSelectionTable = selectedExams => {
		this.setState({ selectedExams }, () => {
			if (selectedExams.length === 0) {
				this.formRef.current.setFieldsValue({ examRequestActive: false });
			}
		});
	};

	onChangeSelectedTable = (examItemID, examData) => {
		const { selectedExams } = this.state;
		const updatedSelectedExams = selectedExams.map(item => {
			if (item.examItemID === examItemID) return Object.assign(item, examData);

			return item;
		});

		this.setState({ selectedExams: updatedSelectedExams });
	};

	closeFormDrawer = () => {
		const { closeForm } = this.props;

		this.setState({ examList: [], selectedExams: [] }, () => {
			this.formRef.current.resetFields();
			this.resetAnalyzer();
		});

		closeForm();
	};

	render() {
		const {
			isLoading,
			isFetchingData,
			examList,
			selectedExams,
			existingDynamicForm,
			newItemAnalyzerValue,
			resetAnalyzerIsTrue,
		} = this.state;
		// eslint-disable-next-line react/prop-types
		const {
			visible,
			examRequest,
			selectedSectionName,
			selectedSpecimenName,
			ddRecords,
		} = this.props;

		const selectedRowKeys = selectedExams.map(exam => (exam ? exam.examItemID : null));

		return (
			<Drawer
				title={`${drawerTitle.update} - ${selectedSectionName} / ${selectedSpecimenName}`.toUpperCase()}
				width="90%"
				placement="right"
				closable
				onClose={this.closeFormDrawer}
				visible={visible}
			>
				<Form ref={this.formRef} onFinish={this.onSubmit} layout="vertical">
					<section style={{ marginBottom: 50 }}>
						<div style={{ margin: '0px 10px' }}>
							<InputForm
								formRef={this.formRef}
								setIsForceDeactivate={this.setIsForceDeactivate}
								examRequest={examRequest}
								ddRecords={ddRecords}
							/>

							<DynamicFormAnalyzer
								handleAnalyzerValue={this.handleAnalyzerValue}
								handleExistingData={existingDynamicForm}
								newItemAnalyzerValue={newItemAnalyzerValue}
								resetAnalyzerIsTrue={resetAnalyzerIsTrue}
							/>

							<Row gutter={12}>
								<Col span={7}>
									<SelectionTable
										data={examList}
										loading={isFetchingData}
										onSelect={this.onSelectSelectionTable}
										onDeselect={this.onDeselectSelectionTable}
										onSelectAll={this.onSelectAllSelectionTable}
										selectedRowKeys={selectedRowKeys}
									/>
								</Col>
								<Col span={17}>
									<SelectedTable
										form={this.formRef.current || {}}
										ref={this.selectedTable}
										data={selectedExams}
										onDragAndDropRow={this.onDragAndDropRow}
										loading={false}
									/>
								</Col>
							</Row>
						</div>
					</section>
					<section className="drawerFooter">
						<div>
							<Button
								shape="round"
								style={{ margin: 10, width: 120 }}
								onClick={this.closeFormDrawer}
							>
								{buttonNames.cancel}
							</Button>
							<UserAccessContext.Consumer>
								{value =>
									value.userAccess.settings.create && (
										<Button
											shape="round"
											type="primary"
											htmlType="submit"
											loading={isLoading}
											style={{ margin: 10, width: 120 }}
										>
											{buttonNames.update}
										</Button>
									)
								}
							</UserAccessContext.Consumer>
						</div>
					</section>
				</Form>
			</Drawer>
		);
	}
}

UpdatePanel.propTypes = {
	sectionId: PropTypes.number,
	specimenId: PropTypes.number,
	examRequestId: PropTypes.number,
	closeForm: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
	examRequest: PropTypes.shape({
		examRequestID: PropTypes.number,
		examRequestName: PropTypes.string,
		examRequestCode: PropTypes.string,
		examRequestLoinc: PropTypes.string,
		examRequestIntegrationCode: PropTypes.string,
		examRequestSort: PropTypes.number,
		sectionID: PropTypes.number,
		specimenID: PropTypes.number,
	}).isRequired,
	selectedSectionName: PropTypes.string,
	selectedSpecimenName: PropTypes.string,
};

UpdatePanel.defaultProps = {
	sectionId: null,
	specimenId: null,
	examRequestId: null,
	selectedSectionName: null,
	selectedSpecimenName: null,
};

export default UpdatePanel;
